import ApolloClient from 'apollo-client'
import createDecorator from 'final-form-calculate'
import { TipoEstabelecimentoEnum } from 'graphql/types.generated'
import { meta } from 'view/atendimentos/atendimento-vacinacao/model'

import { createAgendarConsultasCalculations } from '../../agenda/calculator-agendarConsulta'
import { createNovoAtendimentoCalculations } from '../soap/finalizacao/calculator/calculatorNovoAtendimento'

export const createVacinacaoCalculator = (apollo: ApolloClient<object>, tipoEstabelecimento: TipoEstabelecimentoEnum) =>
  createDecorator(
    ...createAgendarConsultasCalculations(meta.finalizacaoVacinacao.agendamentoConsultas.avulsa),
    ...createNovoAtendimentoCalculations(
      meta.finalizacaoVacinacao.desfechoAtendimento.atendimento,
      tipoEstabelecimento,
      apollo
    )
  )
